import { SyntheticEvent } from 'react';
import { IconPhoto } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import { CanguroGuvery } from '#root/assets';
import styles from './styles.module.scss';

interface DeliveryPhoto {
  id: number | string;
  filename_full_path: string;
}

interface DeliveryPhotosDialogProps {
  open: boolean;
  onClose: () => void;
  images: DeliveryPhoto[];
}

// Si la foto no carga se muestra el canguro de Guvery, como hacía el Avatar anterior
const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
  const image = event.currentTarget;
  image.onerror = null;
  image.src = CanguroGuvery;
  image.dataset.fallback = 'true';
};

/**
 * Fotos que se tomaron al entregar el pedido (sobre el Modal del DS).
 * Cada foto es un enlace a la imagen completa en una pestaña nueva.
 */
const DeliveryPhotosDialog = (props: DeliveryPhotosDialogProps) => {
  const { open, onClose, images } = props;

  return (
    <Modal open={open} onClose={onClose} size="md">
      <ModalHeader icon={<IconPhoto />} tone="info">
        <ModalTitle>Fotos de la entrega</ModalTitle>
        <ModalDescription>Fotos que se tomaron al entregar tu pedido.</ModalDescription>
      </ModalHeader>
      <ModalBody>
        <div className={styles.grid}>
          {images.map((image, index) => (
            <a
              key={image.id}
              className={styles.photo}
              href={image.filename_full_path}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Abrir la foto ${index + 1} en una pestaña nueva`}>
              <img
                src={image.filename_full_path}
                alt={`Foto ${index + 1} de la entrega`}
                loading="lazy"
                onError={handleImageError}
              />
            </a>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeliveryPhotosDialog;
